/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_List_Search_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Search by name, city or VEKN ID..." |
*
* @param {User_List_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_list_search_placeholder = /** @type {((inputs?: User_List_Search_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_List_Search_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher par nom, ville ou VEKN ID...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Buscar por nombre, ciudad o ID VEKN...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Buscar por nome, cidade ou VEKN ID...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cerca per nome, città o VEKN ID...")
	return /** @type {LocalizedString} */ ("Search by name, city or VEKN ID...")
});